const PersonalPronouns = () =>{
    return(
        <>
        <h6>Личные местоимения в английском языке</h6>
        <p>Местоимение — слово, которое заменяет существительное. Местоимение не называет предмет или лицо, а лишь обозначает его. Есть несколько особенностей английских местоимений:</p>
        <ul>
            <li><span>I (я)</span> в английском языке всегда пишется с большой буквы.</li>
            <li><span>He (он)</span> и <span>she (она)</span> используются для обозначения лиц мужского и женского пола соответственно. Также они используются, когда вы говорите о своих домашних питомцах и вам нужно обозначить их пол.</li>
            <li><span>It (оно, это)</span> используется для обозначения неодушевленных предметов, а также животных.</li>
            <li><span>We (мы)</span> обозначает говорящего вместе с группой лиц.</li>
            <li><span>You (ты, вы, Вы)</span> обозначает обращение «ты», обращение к группе людей «вы» и вежливое обращение к одному человеку «Вы».</li>
            <li><span>They (они)</span> употребляется для обозначения одушевленных и неодушевленных предметов во множественном числе.</li>
        </ul>
        <table className="max-w-[1000px] mx-auto">
            <caption className="text-[30px] text-left pb-[10px] ">У личных местоимений есть три основные формы:</caption> 
                <th className=" bg-yellow-300 border-2 w-[300px] py-[20px]">Именительный падеж
                    <br/>
                    <span className=" font-serif italic font-[200]">(Кто?, Что?)</span>      
                </th>
                <th className=" bg-yellow-400 border-2 w-[300px]">Объектный падеж
                    <br/>
                    <span className=" font-serif italic font-[200]">(Кому?, Кого?, Кем?)</span>      
                </th>
                <th className=" bg-yellow-500 border-2 w-[300px]">Притяжательный падеж
                    <br/>
                    <span className=" font-serif italic font-[200]">(Чей?)</span>      
                </th>
            <tbody className=" bg-white">
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">I — я</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">me — мне, меня</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">my — мой</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">he — он</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">him — ему, его</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">his — его</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">she — она</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">her — ей, ее</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">her — ее</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">it — оно (это)</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">it — ему/ей, его/ее</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">its — его/ее</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">we — мы</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">us — нам, нас</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">our — наш</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">you — вы, ты</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">you — вам, вас, тебя, тебе</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">your — ваш, твой</td>
                </tr>
                <tr> 
                    <td className="pl-[20px] border-2 py-[10px] font-serif">they — они</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">them — им, их</td>
                    <td className="pl-[20px] border-2 py-[10px] font-serif">their — их</td>
                </tr>
            </tbody>
        </table>
        <p>
            Именительный падеж: местоимение обозначает предмет или человека, который совершает действие. При этом местоимение выступает в роли подлежащего.
        </p>
        <ul className="example">
            <li><span>I </span>am a manager. — <span>Я</span> менеджер.</li>
            <li><span>It</span> (radio) is working. — <span>Оно</span> (радио) работает.</li>
            <li><span>They</span> are relatives. — <span>Они</span> родственники.</li>
            <li><span>They</span> (shoes) are dirty. — <span>Они</span> (туфли) грязные.</li>
        </ul>
        <p>
            Объектный падеж: на местоимение направлено действие. Здесь местоимение выступает в роли дополнения и отвечает на вопросы «Кому?», «Кого?», «Кем?», а для неодушевленных предметов — «Что?».
        </p>
        <ul className="example">
            <li>Jim is writing a letter to <span>me</span>. — Джим пишет письмо (кому?) <span>мне</span>.</li>
            <li>She is cooking for <span>him</span>. — Она готовит для (кого?) <span>него</span>.</li>
            <li>I am looking at <span>it</span> (picture). — Я смотрю на (что?) <span>это</span> (картину).</li>
        </ul>
        <p>Притяжательный падеж: местоимение показывает принадлежность предмета и отвечает на вопрос «Чей?».</p>
        <ul className="example">
            <li>Nick is <span>my</span> friend. — Ник (чей?) <span>мой</span> друг.</li>
            <li>It’s <span>your</span> cup. — Это (чья?) <span>твоя</span> кружка.</li>
            <li>He is washing <span>her</span> dishes now. — Он моет (чью?) <span>ее</span> посуду сейчас.</li>
        </ul>
        </>
    )
}
export default PersonalPronouns;